// Module
var code = `<div class="playlist-compose-takeover">
  <span class="jumbotron-field-label">Copy as takeover</span>
  <p class="playlist-compose-takeover-note">The copy is this list plus the bumper, spread evenly. This list
    is not changed.</p>

  <div class="playlist-compose-field">
    <label for="takeover-bumper">Bumper</label>
    <input id="takeover-bumper" type="search" class="form-control form-control-sm" placeholder="Search media"
      ng-model="\$ctrl.form.search" ng-change="\$ctrl.refresh()" ng-model-options="{ debounce: 250 }">
    <div class="playlist-compose-takeover-list">
      <button type="button" class="playlist-compose-takeover-choice"
        ng-repeat="media in \$ctrl.view.choices track by media.mediaType + media.mediaId"
        ng-class="{ 'jumbotron-selected': \$ctrl.form.bumper === media }" ng-click="\$ctrl.selectBumper(media)">
        <img class="playlist-compose-thumb" ng-if="media.thumbnailUrl" ng-src="{{ media.thumbnailUrl }}" alt=""
          draggable="false">
        <i class="fas" aria-hidden="true" ng-if="!media.thumbnailUrl"
          ng-class="\$ctrl.typeIcon(media.mediaType)"></i>
        <span class="playlist-compose-name-text">{{ media.name }}</span>
        <span class="jumbotron-note jumbotron-number-cell playlist-compose-sec">{{ media.durationMs | duration }}</span>
      </button>
      <div class="jumbotron-note playlist-compose-empty" ng-if="\$ctrl.view.choices.length === 0">
        No media matches. The bumper has to have an asset for this scene.
      </div>
    </div>
  </div>

  <div class="playlist-compose-field">
    <span class="jumbotron-field-label playlist-compose-field-name">Plays</span>
    <compose-stepper value="\$ctrl.form.count" min="1" on-step="\$ctrl.stepCount(\$delta)"></compose-stepper>
    <label class="playlist-compose-toggle">
      <input type="checkbox" ng-model="\$ctrl.form.first"> On the first slot
    </label>
  </div>

  <div class="playlist-compose-field">
    <label for="takeover-replace">Replace</label>
    <select id="takeover-replace" class="form-select form-select-sm" ng-model="\$ctrl.form.replaceRef">
      <option value="">Nothing</option>
      <option ng-repeat="media in \$ctrl.view.replaceable track by media.ref" value="{{ media.ref }}">
        {{ media.name }} ×{{ media.count }}
      </option>
    </select>
  </div>

  <div class="playlist-compose-field">
    <label for="takeover-name">Name</label>
    <input id="takeover-name" type="text" class="form-control form-control-sm" placeholder="Playlist name"
      ng-model="\$ctrl.form.name" ng-change="\$ctrl.touchName()">
  </div>

  <div class="playlist-compose-field">
    <label for="takeover-start">Start</label>
    <input id="takeover-start" type="datetime-local" class="form-control form-control-sm"
      ng-model="\$ctrl.form.start" ng-change="\$ctrl.timesChanged()">
    <label for="takeover-end">End</label>
    <input id="takeover-end" type="datetime-local" class="form-control form-control-sm"
      ng-model="\$ctrl.form.end" ng-change="\$ctrl.timesChanged()">
  </div>
  <p class="playlist-compose-takeover-note">Both times give an interval with the Takeover role. Leave them
    empty to schedule it in the calendar later.</p>

  <div class="playlist-compose-takeover-actions">
    <span class="jumbotron-note playlist-compose-takeover-problem" ng-if="\$ctrl.view.problem">
      {{ \$ctrl.view.problem }}
    </span>
    <button type="button" class="btn btn-sm btn-outline-secondary" ng-click="\$ctrl.close()"
      ng-disabled="\$ctrl.creating">
      Cancel
    </button>
    <button type="button" class="btn btn-sm btn-primary" ng-click="\$ctrl.create()"
      ng-disabled="\$ctrl.creating || \$ctrl.view.problem">
      <i class="fas fa-fw" aria-hidden="true"
        ng-class="\$ctrl.creating ? 'fa-spinner fa-spin' : 'fa-copy'"></i> Create takeover
    </button>
  </div>
</div>
`;
// Exports
export default code;